import React, { useEffect, useState } from 'react';
import { globals } from '../../misc/globals';
import { getOptionBorder, mapDivEnterToClick } from '../../misc/tools';
import { CalmBaseScenario, ScoreType } from '../../scenarios/CalmBaseScenario';
import { BaseConfig } from '../BaseConfig';
import { UIProperties } from '../UIProperties';

import './YouRespondUI.css'

const YouRespondUI = (props: UIProperties<DialogueUIConfig>) => {
	const [forceUpdate, setForceUpdate] = useState(false);
	const getLetter=(optionIndx: number) => {
		var optionLetters = [
			'A',
			'B',
			'C',
			'D'
		];

		return optionLetters[optionIndx];
	}
	const isSummative = () => {
		return window.location.href.endsWith('6');
	}

	useEffect(() => {
		var update = false;
		if(typeof CalmBaseScenario.answerAttemptCount[CalmBaseScenario.partIndx] === 'undefined') {
			CalmBaseScenario.answerAttemptCount[CalmBaseScenario.partIndx] = 0;
			update = true;
		}
		if(typeof CalmBaseScenario.scores[CalmBaseScenario.partIndx] === 'undefined') {
			CalmBaseScenario.scores[CalmBaseScenario.partIndx] = 0;
			update = true;
		}

		if(update) {
			setForceUpdate(!forceUpdate);
		}
	}, [])

	const getOptionTopPosition=(optionIndx: number) => {
		var indexInReferenceToHiddenObjects = 0;
		
		for(var indx = 0; indx < props.parameters.options.length; indx++) {
			if(optionIndx === indx) {
				break;
			}
			//if the item is hidden, do not account that when positioning this option
			if(!props.parameters.options[indx].hide) {
				indexInReferenceToHiddenObjects++;
			}
		}
		
		switch(indexInReferenceToHiddenObjects) {
			case 0:
				return 69;
			case 1:
				return 181;
			case 2:
				return 291;
			case 3: 
				return 404;
		}
	}

	const getDebugScore = (option: DialogueUIOptionConfig, best: number, ok: number, zero: number, worst: number, worst2: number) => {
		switch(option.scoreType){
			case ScoreType.Best: 
				return best;
			case ScoreType.Ok: 
				return ok;
			case ScoreType.Zero: 
				return zero;
			case ScoreType.Worst: 
				return worst;
			case ScoreType.Worst2: 
				return worst2;
		}
	}

	const getScoreBasedOnAttempt = (option: DialogueUIOptionConfig) => {
		if(isSummative()) {
			switch(option.scoreType) {
				case ScoreType.Best:
					return 100;
				default:
					return 0;
			}
		}

		switch(CalmBaseScenario.answerAttemptCount[CalmBaseScenario.partIndx]) {
			case 0:
				return getDebugScore(option, 1000, 250, 0, -100, -500);
			case 1:
				return getDebugScore(option, 500, 100, 0, -100, -500);
			case 2:
				return getDebugScore(option, 250, 0, 0, -100, -500);
			default:
				return getDebugScore(option, 100, 0, 0, -100, -500);
		}
	}
	return (
		<div className="in-game-ui-container ui-top-most-container">
			
			<div className="you-respond-container center-on-container" style={{
				position: 'relative',
				width: '970px',
				pointerEvents: 'all'
			}}>
				<img src={"./assets/images/general/components/you-respond/you-respond-" + props.parameters.options.filter(o => !o.hide).length + "-options-bg.png"} />
				<p className="title-font" style={{
					position: 'absolute',
					margin: '0',
					top: '14px',
					left: '61px'
				}} tabIndex={0} id='you-respond-first'>You Respond:</p>

				{props.parameters.options.map((o: DialogueUIOptionConfig, i: any) => {
					return (o.hide ? (null) :
						<div key={i} className="pointer" tabIndex={0} id={i === props.parameters.options.length - 1 ? 'you-respond-last' : ''} onMouseEnter={() => {
							var rollOverAudio = document.getElementById('button-rollover');
							
							if(!globals.isMuted) {
								(rollOverAudio as any).play();
							}
						}}
						onKeyUp={mapDivEnterToClick}
						onClick={ () => {
							props.parameters.selectedAnswer = i;
							setForceUpdate(!forceUpdate);
							var clickAudio = document.getElementById('button-click');
							
							if(!globals.isMuted) {
								(clickAudio as any).play();
							}
							if(!o.isCorrect) {
								var audio = document.getElementById('wrong-audio');
								
								if(!globals.isMuted) {(audio as any).play()
								}
							}
							props.parameters.onOptionSelected(o, props.parameters)
						} } style={{
							position: 'absolute',
							left: '19px',
							top: getOptionTopPosition(i) + 'px',
							height: '91px',
							width: '940px',
							border: globals.showDebugForComponents && globals.showDebugAnswerTypes ? getOptionBorder(o.scoreType) : ''
						}}>
							<p className="big-description-font" style={{
								position: 'relative',
								margin: '0px',
								left: '31px',
								top: '44px',
								display: 'inline'
							}}>{getLetter(i) + '.'}</p>

							<p className="big-description-font" style={{
								maxWidth: '810px',
								overflow: 'hidden',
								position: 'absolute',
								top: '50%',
								left: '82px',
								margin: '0',
								padding: '0',
								transform: 'translate(0, -50%)',
								maxHeight: '80px'
							}}>{o.text + (globals.showDebugForComponents && globals.showDebugAnswerTypes ? ' (' + getScoreBasedOnAttempt(o) + ' points)' : '')}</p>
						</div>
					);
				})}
			</div>

			{globals.showDebugForComponents ? (
				<div style={{
					position: 'absolute',
					top: '80px',
					left: '50%',
					transform: 'translate (-50%, 0)',
					pointerEvents: 'all',
					zIndex: 100
				}}>
					<button tabIndex={-1} style={{
						color: 'white',
					}} onClick={() => {
						
						if(typeof CalmBaseScenario.answerAttemptCount[CalmBaseScenario.partIndx] === 'undefined') {
							CalmBaseScenario.answerAttemptCount[CalmBaseScenario.partIndx] = 0;
						}
						CalmBaseScenario.answerAttemptCount[CalmBaseScenario.partIndx]++;
						setForceUpdate(!forceUpdate);	
					}}>
						Increase Answer Attempt
					</button>
				</div>
			) : (null)}

			{globals.showDebugForComponents ? (
				<div style={{
					position: 'absolute',
					top: '110px',
					left: '50%',
					transform: 'translate (-50%, 0)',
					pointerEvents: 'all',
					zIndex: 100
				}}>
					<button tabIndex={-1} style={{
						color: 'white',
					}} onMouseEnter={() => {
						var rollOverAudio = document.getElementById('button-rollover');
						if(!globals.isMuted) {
							(rollOverAudio as any).play();
						}
					}} onClick={() => {	
						if(typeof CalmBaseScenario.answerAttemptCount[CalmBaseScenario.partIndx] === 'undefined') {
							CalmBaseScenario.answerAttemptCount[CalmBaseScenario.partIndx] = 0;
						}
						CalmBaseScenario.answerAttemptCount[CalmBaseScenario.partIndx]--;
						setForceUpdate(!forceUpdate);	
					}}>
						Decrease Answer Attempt
					</button>
				</div>
			) : (null)}

			{globals.showDebugForComponents ? (
				<div tabIndex={-1} style={{
					position: 'absolute',
					top: '130px',
					left: '50%',
					transform: 'translate (-50%, 0)',
					pointerEvents: 'all',
					zIndex: 100
				}}>
					<p style={{
						color: 'white',
						margin: 0
					}}>
						{'Current Attempt: ' + CalmBaseScenario.answerAttemptCount[CalmBaseScenario.partIndx]}
					</p>
				</div>
			) : (null)}
		</div>
	);

};

export interface DialogueUIConfig extends BaseConfig {
	aarScenarioID?: number;
	aarSectionID?: number;
	aarCollectionID?: number[];
	options: DialogueUIOptionConfig[];
	onOptionSelected: (option: DialogueUIOptionConfig, config?: DialogueUIConfig) => void;
	selectedAnswer?: number;
}

export interface DialogueUIOptionConfig {
	text: string;
	isCorrect: boolean;
	feedback?: string;
	hide?: boolean;
	scoreType?: ScoreType;
}

export default YouRespondUI;